import { call, put } from 'redux-saga/effects';
import {
  saveTaxRateTemplateFailure,
  saveTaxRateTemplateSuccess,
} from '../actions';
import { saveTaxRateTemplate } from '../api';
import { SaveTaxRateTemplateRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* saveTaxRateTemplateSaga(
  action: SaveTaxRateTemplateRequestAction
) {
  try {
    let err: ApiError | null;
    const { connectionId, taxRateTemplate } = action.payload;
    const response: ApiResponse = yield call(
      saveTaxRateTemplate,
      connectionId,
      taxRateTemplate
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(saveTaxRateTemplateSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.tax-rate-template-saved-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(saveTaxRateTemplateFailure());
  }
}

